import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Terms: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-bg-primary py-24">
      <div className="container-custom max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">{t('terms.heading')}</h1>
        <p className="text-text-secondary mb-8">{t('terms.effectiveDate')}</p>

        <div className="prose prose-invert max-w-none space-y-8">
          <p className="text-text-secondary mb-8">
            {t('terms.intro')}
          </p>

          <div className="space-y-8">
            <section>
              <h2 className="text-2xl font-bold mb-4">{t('terms.noFinancialAdvice.heading')}</h2>
              <p className="text-text-secondary">
                {t('terms.noFinancialAdvice.text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">{t('terms.eligibility.heading')}</h2>
              <p className="text-text-secondary">
                {t('terms.eligibility.text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">{t('terms.copyTrading.heading')}</h2>
              <p className="text-text-secondary">{t('terms.copyTrading.intro')}</p>
              <ul className="list-disc pl-6 mt-2 text-text-secondary">
                <li>{t('terms.copyTrading.li1')}</li>
                <li>{t('terms.copyTrading.li2')}</li>
                <li>{t('terms.copyTrading.li3')}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">{t('terms.performanceFees.heading')}</h2>
              <p className="text-text-secondary">
                {t('terms.performanceFees.text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">{t('terms.riskDisclosure.heading')}</h2>
              <p className="text-text-secondary">
                {t('terms.riskDisclosure.text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">{t('terms.contactSupport.heading')}</h2>
              <p className="text-text-secondary">
                {t('terms.contactSupport.text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">{t('terms.intellectualProperty.heading')}</h2>
              <p className="text-text-secondary">
                {t('terms.intellectualProperty.text')}
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">{t('terms.changesToTerms.heading')}</h2>
              <p className="text-text-secondary">
                {t('terms.changesToTerms.text')}
              </p>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10">
            <Link to="/" className="btn btn-accent">
              {t('terms.returnHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;